import { render } from "./NavBarBrandIcon.vue?vue&type=template&id=bcfaf2a2&ts=true&lang=html"
import script from "./NavBarBrandIcon.vue?vue&type=script&lang=ts"
export * from "./NavBarBrandIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__